export default class BaseValidator {
  constructor(value, options, errorMessages, id, newRecord, element = null) {
    this.value = value
    this.options = options
    this.errorMessages = errorMessages
    this.id = id
    this.newRecord = newRecord
    this.element = element
  }

  validate() {
    return { valid: false, message: 'Implement me!'}
  }

  get blank() {
    return this.value === null || this.value === undefined || String(this.value).trim() === ''
  }
}
